// The grounding line is on its way (Chris, 2026-10-19). The server sends a
// 'grounding-arriving' frame just before it writes the Mystic's grounding
// line; the reading socket (useReaderConversation) sets this, and clears it
// when the line's first word lands. ChatContainerReader shows three gold dots
// where the line will appear while it is set. One flag for the app: there is
// one reading chat on screen at a time.
import { ref } from 'vue'

export const groundingArriving = ref(false)
